import { useEffect, useRef, useState } from "react";
import FilterInsights from "./FilterInsights";
import InsightsResults from "./InsightsResults";
import { Formik } from "formik";
import STATIC_FILTER from "./staticFilter";
import { useAudience } from "../../hooks/useAudience";

export const Home = () => {
  const formikRef = useRef(null);
  const { handleReset } = useAudience();

  const [showFormikFilter, setShowFormikFilter] = useState(false);

  useEffect(() => {
    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      formikRef.current?.resetForm();
      handleReset();
    };
  }, [handleReset]);

  return (
    <Formik
      onSubmit={() => {}}
      innerRef={formikRef}
      initialValues={STATIC_FILTER}
      validateOnChange={false}
    >
      {/*@ts-ignore*/}
      <FilterInsights
        showFormikFilter={showFormikFilter}
        setShowFormikFilter={setShowFormikFilter}
      >
        <InsightsResults
          //@ts-ignore
          showFormikFilter={showFormikFilter}
          setShowFormikFilter={setShowFormikFilter}
        />
      </FilterInsights>
    </Formik>
  );
};
